import { gql } from "@apollo/client";

export const CRM_LEADS = gql`
  query CrmLeads($where: CrmLeadWhereInput, $take: Int, $skip: Int, $orderBy: [JSONObject], $like: CrmLeadWhereInput, $gt: CrmLeadWhereInput, $lt: CrmLeadWhereInput) {
    crmLeads(where: $where, take: $take, skip: $skip, orderBy: $orderBy, like: $like, gt: $gt, lt: $lt) {
      data {
        id
        email
        firstName
        lastName
        companyName
        phone
        linkedinUrl
        jobTitle
        contactId
        hasContratSante
        hasContratPrevoyance
        hasContratDeces
        cotisationMensuelle
        regime
        departement
        codePostal
        trancheAge
        statut
        tags
        customFields
        createdDate
      }
      count
    }
  }
`;

export const CRM_CAMPAIGN_LEADS = gql`
  query CrmCampaignLeads($where: CrmCampaignLeadWhereInput, $take: Int, $skip: Int, $orderBy: [JSONObject]) {
    crmCampaignLeads(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        campaign { id name }
        lead { id email firstName lastName companyName }
        status
        currentStepId
        currentStepLabel
        stuckSince
        errorMessage
        lastActivityAt
        lastActivityType
      }
      count
    }
  }
`;

export const CRM_ERROR_LOGS = gql`
  query CrmErrorLogs($where: CrmErrorLogWhereInput, $take: Int, $skip: Int, $orderBy: [JSONObject]) {
    crmErrorLogs(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        createdDate
        campaignId
        leadId
        stepId
        errorType
        errorMessage
        leadEmail
        stepLabel
      }
      count
    }
  }
`;

const crmLeads = { CRM_LEADS, CRM_CAMPAIGN_LEADS, CRM_ERROR_LOGS };
export default crmLeads;
